import * as React from "react";
import styled from "../../styled-components";
import Footer from "../../components/Footer/Footer";
import { media } from "../../breakpoints";
import Nav from "../../components/Nav/Nav";
import Helmet from "react-helmet";
import { Subscribe } from "unstated";
import { AppContainer } from "../../containers/App.container";

const Wrapper = styled.div``;

const Header = styled.header`
  background: ${({ theme }) => theme.colors.trueblack};
  color: ${({ theme }) => theme.colors.white};
  padding: 100px 20px;
  margin-top: 25px;

  ${media.PHONE`
    padding-bottom: 50px;
    padding-top: 50px;
  `};

  h1 {
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: 40px;
    font-weight: 600;
    text-align: center;

    ${media.PHONE`
    font-size: 30px;
  `};

    sup {
      margin-right: -10px;
    }
  }
`;

const Main = styled.main`
  color: ${({ theme }) => theme.colors.trueblack};
  font-family: ${({ theme }) => theme.fonts.serif};
  margin: 0 auto;
  max-width: 960px;
  padding: 60px 20px;
  width: 100%;

  ${media.PHONE`
    padding-bottom: 40px;
    padding-top: 40px;
  `};
`;

const Description = styled.p`
  font-size: 20px;
  line-height: 1.1;
  margin: 0 auto;
  max-width: 760px;
  text-align: center;
  width: 100%;

  ${media.PHONE`
    font-size: 16px;
    line-height: 1.25;
  `};
`;

const Form = styled.div`
  background: #f0f0f0;
  margin-top: 50px;
  padding: 50px 100px;

  ${media.PHONE`
    margin-top: 35px;
    padding: 20px;
  `};
`;

const FormTitle = styled.h2`
  border-bottom: 1px solid ${({ theme }) => theme.colors.trueblack};
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -2px;
  padding-bottom: 10px;

  ${media.PHONE`
    font-size: 30px;
    letter-spacing: -1.5px;
  `};
`;

const HubspotForm = styled.div`
  margin-top: 50px;

  ${media.PHONE`
    margin-top: 35px;
  `};

  iframe {
    width: 100% !important; /* This is to style the nasty iframe */
  }
`;

interface IContactLayoutOuterProps {
  formPortalId: string;
  formId: string;
  title: React.ReactNode;
  description: string;
  siteTitle: string;
}

interface IContactLayoutProps extends IContactLayoutOuterProps {
  navOpen: boolean;
  setNavOpen: (navOpen: boolean) => void;
}

export class ContactLayout extends React.Component<IContactLayoutProps> {
  public componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/shell.js";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      if ((window as any).hbspt) {
        (window as any).hbspt.forms.create({
          portalId: this.props.formPortalId,
          formId: this.props.formId,
          target: "#hubspotForm"
        });
      }
    });
  }

  public render() {
    const { description, navOpen, setNavOpen, title, siteTitle } = this.props;
    return (
      <div
        onClick={() => {
          if (navOpen) {
            setNavOpen(false);
          }
        }}
      >
        <Helmet>
          <title>Say | {siteTitle}</title>
        </Helmet>

        <Wrapper>
          <Nav showSayLogo={true} sayLogoFill="#000" />

          <Header>{title}</Header>

          <Main>
            <Description>{description}</Description>

            <Form>
              <FormTitle>Get in touch.</FormTitle>
              <HubspotForm id="hubspotForm" />
            </Form>
          </Main>

          <Footer hideFormOnMobile={true} />
        </Wrapper>
      </div>
    );
  }
}

export default (props: IContactLayoutOuterProps) => (
  <Subscribe to={[AppContainer]}>
    {(app: AppContainer) => (
      <ContactLayout
        {...props}
        navOpen={app.state.navOpen}
        setNavOpen={app.setNavOpen}
      />
    )}
  </Subscribe>
);



// WEBPACK FOOTER //
// ./src/pages/Contact/ContactLayout.tsx